import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "checkbox"]

  toggle() {
    const anyChecked = this.checkboxTargets.some(cb => cb.checked)
    this.formTarget.classList.toggle("d-none", !anyChecked)
  }

  toggleAll(event) {
    const isChecked = event.target.checked
    this.checkboxTargets.forEach(cb => cb.checked = isChecked)
    this.toggle()
  }
}
